<template>
  <div>
    <textarea
      class="form-control"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled">
    </textarea>
  </div>
</template>

<script>
  export default {
    props: {
      rows: {
        type: String,
        required: false
      },
      placeholder: {
        type: String,
        required: false
      },
      value: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false
      }
    }
  }
</script>

<style>    
    
</style>
